<template>
    <div>
    <div>

      <div class="grid grid-cols-6 gap-6">
        <div class="col-span-6 border-gray-200 lg:pr-6 lg:border-r lg:col-span-2">
          <form>
          <div class="flex justify-between">
            <h3 class="text-lg font-medium leading-6 text-gray-900">Raccolta feedback</h3>
                    <span 
                    @click="toogle()"
                    :class="this.form.enable ? 'bg-indigo-600' : 'bg-gray-200'"
                    role="checkbox" 
                    tabindex="0" 
                    aria-checked="false" 
                    class="relative flex-shrink-0 inline-block h-6 transition-colors duration-200 ease-in-out bg-gray-200 border-2 border-transparent rounded-full cursor-pointer w-11 focus:outline-none focus:shadow-outline">
                      <!-- On: "translate-x-5", Off: "translate-x-0" -->
                      <span aria-hidden="true"  :class="this.form.enable ? 'translate-x-5' : 'translate-x-0'" class="inline-block w-5 h-5 transition duration-200 ease-in-out transform translate-x-0 bg-white rounded-full shadow"></span>
                    </span>
                </div>
                <p class="w-64 max-w-full mt-1 text-sm leading-5 text-gray-500">       Abilitando questa funzione puoi permettere ai tuoi clienti di lasciare una recensione privata che ti può aiutare a migliorare il tuo servizio
                </p>
                
                </form>
          </div>
                
                <div class="col-span-6 lg:col-span-4">

                  <div class="flex flex-col">
                    <div class="py-2 -my-2 overflow-x-auto sm:-mx-6 sm:px-6 lg:-mx-8 lg:px-8">
                      <div class="inline-block min-w-full overflow-hidden align-middle border-b border-gray-200 shadow sm:rounded-lg">
                        <table class="min-w-full">
                          <thead>
                            <tr>
                              <th class="px-6 py-3 text-xs font-medium leading-4 tracking-wider text-left text-gray-500 uppercase border-b border-gray-200 bg-gray-50">
                                Recensioni
                              </th>
                            </tr>
                          </thead>
                          <tbody class="bg-white">
                            <tr v-for="review in reviews" :key="review.id">
                              <td class="px-6 py-4 text-sm leading-5 text-gray-500 border-b border-gray-200">
                                {{review.created_at}}
                                <p class="py-2 text-sm font-medium leading-5 text-gray-900 whitespace-no-wrap">
                                  <a :href="'mailto:'+review.email">
                                    {{review.name}} <span class="font-light">|</span> <span class="text-indigo-600">{{review.email}}</span>
                                  </a>
                                </p>
                                {{review.review}}
                              </td>                              
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
      
      </div></div>
    </div>
    <modal v-show="modal.show" :event="modal.event" :icon="modal.icon" :buttonText="modal.buttonText" :buttonClass="modal.buttonClass" :eventclose="modal.eventclose" :title="modal.title" :description="modal.description"></modal>

  </div>
</template>
<script>
import MarketingFeedback from "../apis/MarketingFeedback";
import Modal from "../components/Modal";

export default {
  components: {
    Modal
  },
  data() {
    return {
      id: this.$route.params.id,
      formErrors: {},
      form:{
        enable: false
      },
      reviews: [],
      modal:{
        type: "",
        show: false,
        title: "",
        description: "",
        event: "",
        eventclose: "",
        icon: "",
        buttonText: "",
        buttonClass: "",
      },
    };
  },
  mounted() {
     MarketingFeedback.get(this.id).then(response => {
      this.form = response.data.data;
    });

    MarketingFeedback.getReviews(this.id).then(response => {
      this.reviews = response.data.data;
    });
  },
  created(){
  },
  methods: {
    toogle(){
        this.form.enable = !this.form.enable;
        this.onSubmit();
    },

    onSubmit: function() { 
        this.$store.dispatch("updateSpinner", true);
        MarketingFeedback.update(this.id, this.form)
          .then(() => {
            this.$store.dispatch("updateSpinner", false);
            this.$store.dispatch("addNotification", {id: Math.floor(Math.random() * 100000), title : "Salvato", description: ""});
        })
        .catch(error => {
          if (error.response.status === 422) {
            this.formErrors = error.response.data.errors;
            if (this.formErrors.privacy_policy){

              this.$root.$on('clickGoToPP' + this.id, () => {
                  this.$router.push({ name: "MarketingPrivacyPolicy"}).catch(()=>{});
              });

              this.$root.$on('clickCloseModalGoToPP' + this.id, () => {
                this.modal.show = false;
              });


              this.modal.event = 'clickGoToPP' + this.id;
              this.modal.eventclose = 'clickCloseModalGoToPP' + this.id;
              this.modal.title = "Attenzione";
              this.modal.description = "Per attivare questa funzione è necessario specificare la privacy policy per ciascuna lingua abilitata nel menu";
              this.modal.icon = "alert";
              this.modal.buttonText = "Inserisci Privacy Policy";
              this.modal.buttonClass = "bg-green-400 hover:bg-green-500  focus:border-green-400 focus:shadow-outline-green";
              this.modal.show = true;
            }
          }
          this.$store.dispatch("updateSpinner", false);
          this.form.enable = false;

        });
       
    },
  }
};
</script>
